import { useMemo as o } from "react";
import { useAtomValue as r } from "jotai";
import { getConfigPropertyAtomCreator as e, ConfigProperty as t } from "./index13.mjs";
import { DEFAULT_LANGUAGE as m } from "./index52.mjs";
const c = () => r(
  o(() => e(t.LOCALE), [])
) || window.I18n.locale || m;
export {
  c as useLocale
};
